"use client"

import { Drawer, DrawerProps, Row } from "antd"
import { forwardRef, ReactNode, useCallback, useImperativeHandle, useState } from "react"
import PageHeaderMobile, { PageHeaderMobileProps } from "../PageHeaderMobile"
import PageFooterMobile from "../PageFooterMobile"

export type PageDrawerMobileRef = {
  open: () => void,
  close: () => void,
}

export type PageDrawerMobileProps = DrawerProps & {
  headerProps?: PageHeaderMobileProps,
  footer?: ReactNode,
  hiddenHeader?: boolean
}

const PageDrawerMobile = forwardRef<PageDrawerMobileRef, PageDrawerMobileProps>(({ hiddenHeader, children, styles, footer, headerProps, width, height, size, className, ...props }, ref) => {
  const [open, setOpen] = useState<boolean>(false)
  const drawerSize = size ?? width ?? height
  const drawerProps = { ...props } as DrawerProps & { width?: unknown; height?: unknown }
  const styleMap = typeof styles === 'function' ? undefined : styles

  delete drawerProps.width
  delete drawerProps.height

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose
    }
  }, [handleClose, handleOpen])

  return (
    <Drawer
      open={open}
      size={drawerSize}
      className={["page__drawer", className].filter(Boolean).join(" ")}
      classNames={{
        header: 'page__drawer-header',
        wrapper: 'page__drawer-wrapper',
        body: 'page__drawer-body'
      }}
      styles={{
        ...styleMap,
        body: {},
        mask: {
          top: "6rem",
          ...styleMap?.mask,
        },
        wrapper: {
          top: "6rem",
          boxShadow: "none",
          ...styleMap?.wrapper,

        },
        // content: {},
        footer: {}
      }}
      onClose={handleClose}
      maskClosable={false}
      footer={footer && <PageFooterMobile content={footer} style={styleMap?.footer} />}
      {...drawerProps}
    >
      {!hiddenHeader && (
        <PageHeaderMobile
          {...headerProps}
          onLeftClick={() => {
            if (headerProps?.onLeftClick) {
              headerProps?.onLeftClick()
            }
            handleClose()
          }}
        />
      )}
      <Row className="page__drawer-content" style={{ ...styleMap?.body }}>
        {children}
      </Row>
    </Drawer>
  )
})

PageDrawerMobile.displayName = 'PageDrawerMobile'

export default PageDrawerMobile